(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.category-carousel').forEach(function (carousel) {
    var track = carousel.querySelector('[data-category-track]');
    var counter = carousel.closest('.template-section').querySelector('[data-category-current]');
    var prev = carousel.querySelector('[data-category-prev]');
    var next = carousel.querySelector('[data-category-next]');

    function step() {
      var item = track.firstElementChild;
      return item ? item.getBoundingClientRect().width + 20 : 260;
    }
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: step() * -2, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step() * 2, behavior: 'smooth' });
    });
    if (counter) {
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () {
          counter.textContent = Math.round(track.scrollLeft / step()) + 1;
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.featured-collection__carousel').forEach(function (carousel) {
    var section = carousel.closest('.template-section');
    if (!section) return;
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    function step() {
      var item = carousel.firstElementChild;
      return item ? item.getBoundingClientRect().width + 20 : 240;
    }
    if (prev) prev.addEventListener('click', function () {
      carousel.scrollBy({ left: step() * -2, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      carousel.scrollBy({ left: step() * 2, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.locale-modal').forEach(function (modal) {
    var overlay = modal.querySelector('[data-locale-overlay]');
    var close = modal.querySelector('[data-locale-close]');
    if (overlay) {
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) modal.removeAttribute('open');
      });
    }
    if (close) {
      close.addEventListener('click', function () {
        modal.removeAttribute('open');
      });
    }
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') modal.removeAttribute('open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hero-slider').forEach(function (slider) {
    var track = slider.querySelector('[data-slider-track]');
    var slides = track.children;
    var current = slider.querySelector('[data-slider-current]');
    var dots = slider.querySelectorAll('[data-slide-to]');
    var index = 0;
    var timer = null;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
    }

    function fitHeight() {
      var active = slides[index];
      if (active) {
        track.style.height = active.getBoundingClientRect().height + 'px';
      }
    }

    function sync() {
      index = Math.round(track.scrollLeft / track.clientWidth);
      if (current) current.textContent = index + 1;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('hero-slider__dot--active', i === index);
      });
      fitHeight();
    }

    fitHeight();
    window.addEventListener('resize', fitHeight);
    window.addEventListener('load', fitHeight);

    var prev = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-slide-to'), 10));
      });
    });
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(sync);
    });

    if (slider.getAttribute('data-autoplay') === 'true' && slides.length > 1) {
      var speed = parseInt(slider.getAttribute('data-speed'), 10) * 1000 || 6000;
      function start() { timer = setInterval(function () { goTo(index + 1); }, speed); }
      function stop() { clearInterval(timer); }
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      start();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('.collection-toolbar__views').forEach(function (views) {
    var grid = document.querySelector('[data-product-grid]');
    if (!grid) return;
    var buttons = views.querySelectorAll('[data-view]');

    function apply(view) {
      grid.classList.toggle('product-grid--list', view === 'list');
      buttons.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-view') === view);
      });
      try { localStorage.setItem('collection-view', view); } catch (e) {}
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        apply(button.getAttribute('data-view'));
      });
    });

    try {
      var saved = localStorage.getItem('collection-view');
      if (saved === 'list') apply('list');
    } catch (e) {}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = thumb.closest('.product-gallery').querySelector('.product-gallery__main img');
      if (main) main.src = thumb.getAttribute('data-full-src');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
